import { useMemo } from "react";
import {
  processLaunchableData,
  type ProcessedLaunchableData,
} from "components/Launchables/utils";
import { LaunchableRequestError } from "server/brevdeploy/launchables/api";
import { useLaunchableQuery } from "server/brevdeploy/launchables/queries";

export function useLaunchableDeployQuery(
  launchableId: string,
  isPublic: boolean,
) {
  const query = useLaunchableQuery(
    launchableId,
    isPublic ? "public" : "authenticated",
  );
  const processedLaunchable = useMemo<{
    data: ProcessedLaunchableData | null;
    failed: boolean;
  }>(() => {
    if (!query.data) return { data: null, failed: false };
    const data = processLaunchableData(query.data);
    return { data, failed: data === null };
  }, [query.data]);
  const requestError =
    query.error instanceof LaunchableRequestError ? query.error : null;
  const launchableNotFound = requestError?.notFound ?? false;
  const launchableAccessError = requestError?.accessDenied ?? false;
  const launchableLoadError =
    processedLaunchable.failed ||
    (!!query.error && !launchableNotFound && !launchableAccessError);

  return {
    launchableData: processedLaunchable.data,
    rawLaunchableData: query.data ?? null,
    loading: query.isInitialLoading,
    retrying: query.isFetching && !query.isInitialLoading,
    launchableNotFound,
    launchableAccessError,
    launchableLoadError,
    refetch: query.refetch,
  };
}
